<template>
    <div>
        <compra-direta-ferramenta-de-busca v-model="filtrosBuscaAvancada"
                                           :situacoesPossiveis="situacoesCompraDireta"
                                           :placeholderPesquisa="placeholderPesquisa"
                                           :filtros="filtrosInterno"
                                           @eventoBuscaSimples="tratarEventoBuscaSimples"
                                           @eventoRemoverFiltro="tratarEventoRemoverFiltro"
                                           @eventoBuscaAvancada="processarEventoBuscarAvancada"
                                           @updateSituacoes="(situacoes) => filtrosBuscaAvancada.situacoes = situacoes">
        </compra-direta-ferramenta-de-busca>

        <listagem-compra-direta-situacao-unica :itens="itens"
                                               :paginas="paginas" :total-itens="totalItens"
                                               :paginacao="$store.state.comprador.resultadoBuscaComprasDiretasEmElaboracao.paginacao"
                                               :textoVazio="'Não há compras diretas em elaboração'"
                                               @paginar="tratarEventoPaginar"
                                               @excluir="processarEventoExcluirCompra"
                                               @acessar="tratarEventoAcessar"/>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogExclusao"
                              textoSecundario="Deseja realmente excluir a compra direta?"
                              tamanhoMaximo="320"
                              @confirmado="excluirCompra"
                              @recusado="fecharModalConfirmacaoExclusao"/>
    </div>
</template>

<script>
import _ from 'lodash'
import azAuth from '@azinformatica/loki/src/utils/az-auth'
import {actionTypes, mutationTypes} from '@/core/constants'
import ListagemCompraDiretaSituacaoUnica from '@/views/pages/commons/listagem-compra-direta-situacao-unica/ListagemCompraDiretaSituacaoUnica'
import CompraDiretaFerramentaDeBusca from '@/views/pages/commons/busca-avancada/CompraDiretaFerramentaDeBusca'

export default {
    name: 'ComprasDiretasEmElaboracao',
    components: {
        CompraDiretaFerramentaDeBusca,
        ListagemCompraDiretaSituacaoUnica
    },
    data() {
        return {
            filtrosInterno: this.getFiltrosComprasDiretasEmElaboracao(),
            filtrosBuscaAvancada: this.getFiltrosBuscaAvancada(),
            itens: [],
            paginas: 0,
            totalItens: 0,
            ehBuscaAvancada: false,
            mostrarDialogExclusao: false
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_COMPRA_DIRETA_EM_ELABORACAO, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_COMPRAS_DIRETAS_EM_ELABORACAO)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.resetFiltroBuscaAvancada()
        },
        tratarEventoPaginar(paginacao) {
            if(this.ehBuscaAvancada) {
                this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacao)
                this.processarEventoBuscarAvancada()
            }else {
                this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ELABORACAO, paginacao)
                this.buscar()
            }
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.resetFiltroBuscaAvancada()
            this.filtrosBuscaAvancada = this.getFiltrosBuscaAvancada()
            this.buscar()
        },
        tratarEventoAcessar(id) {
            this.$store.commit(mutationTypes.SET_ROTA_ORIGEM, 'ComprasDiretasEmElaboracao')
            if (azAuth(this.$store.state.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])) {
                this.$router.push({name: 'DadosGeraisEdicao', params: {id}})
            } else {
                this.$router.push({name: 'DadosGeraisVisualizacao', params: {id}})
            }
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.objeto.value = valor
                this.filtrosInterno.conteudo = valor
                this.buscar()
            }
        },
        async excluirCompra() {
            if(this.compraDiretaId) {
                await this.$store.dispatch(actionTypes.REMOVER_COMPRA_DIRETA, { compraDiretaId: this.compraDiretaId, removerNaOrigem: true })
                this.mostrarNotificacaoSucesso('Compra direta excluída com sucesso.')
                const index = this.itens.findIndex(compra => compra.id === this.compraDiretaId)
                this.itens.splice(index, 1)
                this.fecharModalConfirmacaoExclusao()
            }else {
                this.mostrarNotificacaoErro('Não foi possível excluir a compra direta. Detalhes (O identificador da compra direta está nulo).')
            }
        },
        fecharModalConfirmacaoExclusao(){
            this.mostrarDialogExclusao = false
            this.compraDiretaId = null
        },
        async processarEventoExcluirCompra(compraDiretaId) {
            this.compraDiretaId = compraDiretaId
            this.mostrarDialogExclusao = true
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        getFiltrosComprasDiretasEmElaboracao() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaComprasDiretasEmElaboracao.filtros)
        },
        getFiltrosBuscaAvancada() {
            return _.cloneDeep(this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.filtros)
        },
        resetFiltroBuscaAvancada(){
            this.ehBuscaAvancada = false
            this.$store.state.comprador.resultadoBuscaAvancadaComprasDiretas.reset()

            /**
             * TODO Refatorar o funcionamento da busca avançada para se usar o esquema da busca simples
             *  e depois remove essas linhas abaixo, e também o atributo ehBuscaAvancada
             */

            const paginacaoInicial = {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            }
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_COMPRA_DIRETA_EM_ELABORACAO, paginacaoInicial)
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, paginacaoInicial)
        },
        async processarEventoBuscarAvancada() {
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_AVANCADA_COMPRAS_DIRETAS_COMPRADOR, this.filtrosBuscaAvancada)
            this.setMensagemLoading('Carregando compras diretas...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AVANCADA_COMPRAS_DIRETAS_COMPRADOR)
            this.itens = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements

            this.ehBuscaAvancada = true
        },
    },
    computed: {
        placeholderPesquisa() {
            const texto = this.$t('main.commons_listagem_situacao.text').toLowerCase()
            return `Busque por: nº processo, nº consulta, objeto ou ${texto}`
        }
    }
}
</script>
